import { IconClose } from "@/assets/icons";
import { INPUT_MAX_LENGTH_MESSAGE, MAX_CHARACTER_INPUT_VALIDATION } from "@/constants/common";
import { blue } from "@/theme/colors";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { memo } from "react";
export type TEditableNoteField = "permanentEmploymentNote" | "separationStatusNote" | "remarks";
export const isLedgerNoteValueValid = (value: string) => value.length <= MAX_CHARACTER_INPUT_VALIDATION;
type TProps = {
    row: {
        caseMatchId: number | null;
    };
    field: TEditableNoteField;
    value: string;
    isEditing: boolean;
    onChange: (caseMatchId: number, field: TEditableNoteField, value: string) => void;
};
const EDIT_CELL_HEIGHT = 33;
export const LedgerNoteEditableCell = memo(({ row, field, value, isEditing, onChange }: TProps) => {
    if (!isEditing || row.caseMatchId == null) {
        return <Box component="span" sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{value}</Box>;
    }
    const caseMatchId = row.caseMatchId;
    return <NoteTextCell value={value} onChange={(next) => onChange(caseMatchId, field, next)} />;
});
type TNoteTextCellProps = {
    value: string;
    onChange: (value: string) => void;
};
const NoteTextCell = ({ value, onChange }: TNoteTextCellProps) => {
    const isOverLimit = value.length > MAX_CHARACTER_INPUT_VALIDATION;
    return (<Box sx={{ display: "flex", alignItems: "center", minHeight: EDIT_CELL_HEIGHT, position: "relative" }}>
      <TextField fullWidth size="small" placeholder="入力内容" value={value} error={isOverLimit} helperText={isOverLimit ? INPUT_MAX_LENGTH_MESSAGE(MAX_CHARACTER_INPUT_VALIDATION) : undefined} onChange={(e) => onChange(e.target.value)} sx={{
            "& .MuiOutlinedInput-root": { height: EDIT_CELL_HEIGHT, alignItems: "center" },
            "& .MuiOutlinedInput-root:hover:not(.Mui-error) .MuiOutlinedInput-notchedOutline": { borderColor: blue[70] },
            "& .MuiOutlinedInput-input": { paddingTop: 0, paddingBottom: 0, height: "100%", lineHeight: `${EDIT_CELL_HEIGHT}px` },
            "& .MuiFormHelperText-root": { position: "absolute", top: "100%", left: 0, marginTop: 0, marginLeft: "4px", lineHeight: 1.2 },
        }} InputProps={{
            endAdornment: value ? (<InputAdornment position="end">
              <IconButton size="small" edge="end" onClick={() => onChange("")}>
                <IconClose width={16} height={16}/>
              </IconButton>
            </InputAdornment>) : undefined,
        }}/>
    </Box>);
};
